/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * exemONE 대상 Icon Api
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  CommonTargetIconRequest,
  SuccessResponse,
  TargetIconInitDataResponse,
  TargetIconMappingResponse,
  TargetIconMenuResponse,
  TargetIconRequest,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary updateTargetIcon
 */
export const postV8TargetIcon = (
  targetIconRequest: MaybeRef<TargetIconRequest[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  targetIconRequest = unref(targetIconRequest);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v8/target-icon`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: targetIconRequest,
      signal,
    },
    options,
  );
};

export const getPostV8TargetIconMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8TargetIcon>>,
    TError,
    { data: BodyType<TargetIconRequest[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8TargetIcon>>,
  TError,
  { data: BodyType<TargetIconRequest[]> },
  TContext
> => {
  const mutationKey = ['postV8TargetIcon'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8TargetIcon>>,
    { data: BodyType<TargetIconRequest[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8TargetIcon(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8TargetIconMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8TargetIcon>>
>;
export type PostV8TargetIconMutationBody = BodyType<TargetIconRequest[]>;
export type PostV8TargetIconMutationError = ErrorType<unknown>;

/**
 * @summary updateTargetIcon
 */
export const usePostV8TargetIcon = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8TargetIcon>>,
      TError,
      { data: BodyType<TargetIconRequest[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8TargetIcon>>,
  TError,
  { data: BodyType<TargetIconRequest[]> },
  TContext
> => {
  const mutationOptions = getPostV8TargetIconMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary initTargetIconMapping
 */
export const getV8TargetIconInit = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<TargetIconInitDataResponse>(
    { url: `/api/v8/target-icon/init`, method: 'GET', signal },
    options,
  );
};

export const getGetV8TargetIconInitQueryKey = () => {
  return ['api', 'v8', 'target-icon', 'init'] as const;
};

export const getGetV8TargetIconInitQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8TargetIconInit>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV8TargetIconInit>>, TError, TData>>;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8TargetIconInitQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8TargetIconInit>>> = ({ signal }) =>
    getV8TargetIconInit(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8TargetIconInit>>,
    TError,
    TData
  >;
};

export type GetV8TargetIconInitQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8TargetIconInit>>
>;
export type GetV8TargetIconInitQueryError = ErrorType<unknown>;

/**
 * @summary initTargetIconMapping
 */

export function useGetV8TargetIconInit<
  TData = Awaited<ReturnType<typeof getV8TargetIconInit>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8TargetIconInit>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8TargetIconInitQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getTargetIconMenu
 */
export const postV8TargetIconMenu = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<TargetIconMenuResponse>(
    { url: `/api/v8/target-icon/menu`, method: 'POST', signal },
    options,
  );
};

export const getPostV8TargetIconMenuMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8TargetIconMenu>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8TargetIconMenu>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postV8TargetIconMenu'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8TargetIconMenu>>,
    void
  > = () => {
    return postV8TargetIconMenu(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8TargetIconMenuMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8TargetIconMenu>>
>;

export type PostV8TargetIconMenuMutationError = ErrorType<unknown>;

/**
 * @summary getTargetIconMenu
 */
export const usePostV8TargetIconMenu = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8TargetIconMenu>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8TargetIconMenu>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostV8TargetIconMenuMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary resetTargetIcon
 */
export const postV8TargetIconReset = (
  commonTargetIconRequest: MaybeRef<CommonTargetIconRequest[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  commonTargetIconRequest = unref(commonTargetIconRequest);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v8/target-icon/reset`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: commonTargetIconRequest,
      signal,
    },
    options,
  );
};

export const getPostV8TargetIconResetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8TargetIconReset>>,
    TError,
    { data: BodyType<CommonTargetIconRequest[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8TargetIconReset>>,
  TError,
  { data: BodyType<CommonTargetIconRequest[]> },
  TContext
> => {
  const mutationKey = ['postV8TargetIconReset'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8TargetIconReset>>,
    { data: BodyType<CommonTargetIconRequest[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8TargetIconReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8TargetIconResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8TargetIconReset>>
>;
export type PostV8TargetIconResetMutationBody = BodyType<CommonTargetIconRequest[]>;
export type PostV8TargetIconResetMutationError = ErrorType<unknown>;

/**
 * @summary resetTargetIcon
 */
export const usePostV8TargetIconReset = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8TargetIconReset>>,
      TError,
      { data: BodyType<CommonTargetIconRequest[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8TargetIconReset>>,
  TError,
  { data: BodyType<CommonTargetIconRequest[]> },
  TContext
> => {
  const mutationOptions = getPostV8TargetIconResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getTargetsByGroup
 */
export const postV8TargetIconTargets = (
  commonTargetIconRequest: MaybeRef<CommonTargetIconRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  commonTargetIconRequest = unref(commonTargetIconRequest);

  return customAxiosInstance<TargetIconMappingResponse>(
    {
      url: `/api/v8/target-icon/targets`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: commonTargetIconRequest,
      signal,
    },
    options,
  );
};

export const getPostV8TargetIconTargetsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8TargetIconTargets>>,
    TError,
    { data: BodyType<CommonTargetIconRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8TargetIconTargets>>,
  TError,
  { data: BodyType<CommonTargetIconRequest> },
  TContext
> => {
  const mutationKey = ['postV8TargetIconTargets'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8TargetIconTargets>>,
    { data: BodyType<CommonTargetIconRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8TargetIconTargets(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8TargetIconTargetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8TargetIconTargets>>
>;
export type PostV8TargetIconTargetsMutationBody = BodyType<CommonTargetIconRequest>;
export type PostV8TargetIconTargetsMutationError = ErrorType<unknown>;

/**
 * @summary getTargetsByGroup
 */
export const usePostV8TargetIconTargets = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8TargetIconTargets>>,
      TError,
      { data: BodyType<CommonTargetIconRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8TargetIconTargets>>,
  TError,
  { data: BodyType<CommonTargetIconRequest> },
  TContext
> => {
  const mutationOptions = getPostV8TargetIconTargetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
